/* eslint-disable */
import { Component, HostListener, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { LoggerService } from 'src/app/services/logger.service';
import { isTopOverlay } from 'src/app/utils/overlay-controller.utils';

@Component({
  selector: 'app-time-typein',
  templateUrl: './time-typein.page.html',
  styleUrls: ['./time-typein.page.scss']
})
export class TimeTypeinPage implements OnInit {
  activePerson: any = {};
  stopIdx: number;
  field: string;
  timeBounds: any;
  notEnoughTime = false;

  // inputs from view
  hrsInput = '';
  minsInput = '';
  isAM: boolean;
  isNextDay = false;

  hrs = 0;
  mins = 0;

  minMoment;
  maxMoment;
  minTimeDisplay = '';
  maxTimeDisplay = '';
  minHrs: number;
  minMins: number;
  maxHrs: number;
  maxMins: number;

  nextDayDisplay = '';

  errorBadTime = false;
  errorTooEarly = false;
  errorTooLate = false;
  prompt = '';

  constructor(
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
    private translate: TranslateService,
    private logger: LoggerService
  ) {}

  onChangeIsNextDay() {
    if (this.isNextDay === true) {
      this.isAM = true;
    }
  }

  setMinMaxTimes() {
    const idx = this.stopIdx;
    const stops = this.activePerson.stops;
    const field = this.field;
    const ymdMoment = moment(this.activePerson.ymd, 'YYYYMMDD');
    const minTimeSecs = this.timeBounds.start.secs;
    const maxTimeSecs = this.timeBounds.stop.secs;

    const getMinSecs = () => {
      let counter = 0;
      if (field === 'FROM') {
        for (let i = idx - 1; i >= 0; i--) {
          const stop = stops[i];
          if (stop.out.hasOwnProperty('time') && stop.out.time != null) {
            return stop.out.time.secs;
          }
          if (stop.in.hasOwnProperty('time') && stop.in.time != null) {
            return stop.in.time.secs;
          }
        }
      }
      if (field === 'TO') {
        for (let i = idx; i >= 0; i--) {
          const stop = stops[i];
          if (counter !== 0 && stop.out.hasOwnProperty('time') && stop.out.time != null) {
            return stop.out.time.secs;
          }
          if (stop.in.hasOwnProperty('time') && stop.in.time != null) {
            return stop.in.time.secs;
          }
          counter++;
        }
      }

      return minTimeSecs;
    };

    const getMaxSecs = () => {
      let counter = 0;
      if (field === 'FROM') {
        for (let i = idx; i < stops.length; i++) {
          const stop = stops[i];
          // don't use arrive time current stop
          if (counter !== 0 && stop.in.hasOwnProperty('time') && stop.in.time != null) {
            return stop.in.time.secs;
          }
          if (stop.out.hasOwnProperty('time') && stop.out.time != null) {
            return stop.out.time.secs;
          }
          counter++;
        }
      }
      if (field === 'TO') {
        for (let i = idx + 1; i < stops.length; i++) {
          const stop = stops[i];
          if (stop.in.hasOwnProperty('time') && stop.in.time != null) {
            return stop.in.time.secs;
          }
          if (stop.out.hasOwnProperty('time') && stop.out.time != null) {
            return stop.out.time.secs;
          }
        }
      }

      return maxTimeSecs;
    };

    // get min/max seconds from trip surveys
    const minSecs = getMinSecs();
    const maxSecs = getMaxSecs();

    // get min/max moments for validation
    this.minMoment = moment(minSecs, 'X');
    this.maxMoment = moment(maxSecs, 'X');

    // get min/max hours
    this.minHrs = this.minMoment.hour();
    this.maxHrs = this.maxMoment.hour();

    // if max time is the next day, max hrs need to be b/w 24 and 27
    if (this.minMoment.isSame(this.maxMoment, 'day') === false) {
      this.maxHrs = this.maxHrs + 24;
    }

    // get min/max minutes
    this.minMins = this.minMoment.minute();
    this.maxMins = this.maxMoment.minute();

    this.minTimeDisplay = this.minMoment.isSame(ymdMoment, 'day') ? this.minMoment.format('LT') : this.minMoment.format('LL');
    this.maxTimeDisplay = this.maxMoment.isSame(ymdMoment, 'day') ? this.maxMoment.format('LT') : this.maxMoment.format('LL');
  }

  setTimesOnLoad() {
    const myStop = this.activePerson.stops[this.stopIdx];
    const myTime = this.field === 'FROM' ? myStop.in.time : myStop.out.time;

    if (myTime == null || myTime.secs == null) {
      const time = this.minMoment.clone().add(1, 'minute');
      this.isNextDay = time.isSame(moment(this.activePerson.ymd, 'YYYYMMDD'), 'day') === false;
      this.hrs = time.hour();
      this.mins = time.minute();
    } else {
      const myMoment = moment(myTime.secs, 'X');
      this.isNextDay = myMoment.isSame(moment(this.activePerson.ymd, 'YYYYMMDD'), 'day') === false;
      this.hrs = this.isNextDay ? myMoment.hour() + 24 : myMoment.hour();
      this.mins = myMoment.minute();
    }

    // 0 - 11 is AM
    // 12 - 23 is PM
    if (this.hrs === 0) {
      this.isAM = true;
      this.hrs = 12;
    } else if (this.hrs < 12) {
      this.isAM = true;
    } else if (this.hrs === 12) {
      this.isAM = false;
    } else if (this.hrs > 12 && this.hrs < 24) {
      this.isAM = false;
      this.hrs -= 12;
    } else if (this.hrs === 24) {
      this.isAM = true;
      this.hrs -= 12;
    } else {
      this.isAM = true;
      this.hrs -= 24;
    }

    this.hrsInput = this.hrs.toString();
    this.minsInput = this.mins.toString();

    if (this.minsInput.length === 1) {
      this.minsInput = '0' + this.minsInput;
    }

    this.nextDayDisplay = moment(this.activePerson.ymd, 'YYYYMMDD').add(1, 'day').format('ll');
  }

  onSubmit() {
    this.errorBadTime = false;
    this.errorTooEarly = false;
    this.errorTooLate = false;

    if (isNaN(parseInt(this.hrsInput)) || isNaN(parseInt(this.minsInput))) {
      this.errorBadTime = true;
      return;
    }

    this.hrs = parseInt(this.hrsInput);
    this.mins = parseInt(this.minsInput);

    if (this.hrs < 1 || this.hrs > 12) {
      this.errorBadTime = true;
      return;
    }

    if (this.mins < 0 || this.mins >= 60) {
      this.errorBadTime = true;
      return;
    }

    const time = moment(this.activePerson.ymd, 'YYYYMMDD');

    if (this.hrs === 12 && this.isAM === true) {
      this.hrs = 0;
    } else if (this.hrs !== 12 && this.isAM === false) {
      this.hrs += 12;
    }

    if (this.isNextDay) {
      this.hrs += 24;
    }

    time.add(this.hrs, 'hours');
    time.add(this.mins, 'minutes');

    if (time.isSameOrBefore(this.minMoment)) {
      this.errorTooEarly = true;
      return;
    }

    if (time.isSameOrAfter(this.maxMoment)) {
      this.errorTooLate = true;
      return;
    }

    const baseTime = moment(this.activePerson.ymd, 'YYYYMMDD');
    const mins = moment.duration(time.diff(baseTime)).asMinutes();
    const timeDisplay = this.isNextDay ? time.format('LL') : time.format('LT');

    this.popoverCtrl.dismiss({
      mins,
      display: timeDisplay,
      secs: time.unix()
    });
  }

  @HostListener('document:keydown.escape', ['$event'])
  async handleKeyboardEvent(event: KeyboardEvent) {
    const isTop = await isTopOverlay(this.popoverCtrl, TimeTypeinPage);
    if (isTop) {
      this.dismiss();
    }
  }

  dismiss() {
    this.popoverCtrl.dismiss();
  }

  init() {
    this.activePerson = this.navParams.data.activePerson;
    this.stopIdx = this.navParams.data.stopIdx;
    this.field = this.navParams.data.field;
    this.timeBounds = this.navParams.data.timeBounds;

    this.setMinMaxTimes();
    this.setTimesOnLoad();

    this.prompt = this.field === 'FROM' ? this.translate.instant('TIME_TYPE_IN_ARRIVED') : this.translate.instant('TIME_TYPE_IN_DEPARTED');
    this.prompt += ': ' + this.activePerson.stops[this.stopIdx].label;
  }

  ngOnInit() {
    this.init();
  }
}
